// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"Dialogs_dialogTitle__1CKy5","linkToRelated":"Dialogs_linkToRelated__25wUA"};